import {Questionary} from "../../model/questionary";
import m, {Vnode} from "mithril";

export default class FinishedSaving {
    constructor(
        public readonly questionary: Questionary,
    ) { }

    public view(): Vnode {

        let failedMessages;
        switch (this.questionary.savingStatus) {
            case "problems":
                failedMessages = [
                    m('.loader-message', {}, m.trust(this.questionary.messages.get('savingTakesLongerThanUsual'))),
                    m('.loader-message'),
                ];
                break;
            case "failed":
                failedMessages = [
                    m('.loader-message', {}, m.trust(this.questionary.messages.get('savingFailed'))),
                    m('.loader-message', {},
                        m('button.btn.large.raised.primary', {
                            onclick: () => {
                                this.questionary.savingStatus = '';
                                this.questionary.save();
                            }
                        }, this.questionary.messages.get('tryAgain'))
                    ),
                ];
                break;
            default:
                failedMessages = [
                    m('.loader-message'),
                    m('.loader-message'),
                ];
        }

        return m('.form.loading', {}, [
            m('.loader', {}, [
                m('.loader-spinner'+(this.questionary.savingStatus === 'failed' ? '.stop' : '')),
                m('.loader-message', {}, m.trust(this.questionary.messages.get('questionaryFinished'))),
                ...failedMessages,
            ]),
        ])
    }
}